require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-when-times-get-tough.json") })
        }
      }, "path---es-articles-when-times-get-tough");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-when-times-get-tough!./.cache/json/es-articles-when-times-get-tough.json
// module id = 2481
// module chunks = 231608221292675